import Vue from 'vue'
import VueRouter from 'vue-router'

import NoFound from "../views/NoFound.vue"

import Index from "../views/Index.vue"

import Mall from "../views/Shop/Mall.vue"

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(/* c8 ignore next */ err => { })
};

Vue.use(VueRouter); //使用插件

// 官网
const routesIndex = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta:{//初始化的meta
      isShow:true,
      title:'',
      content:{
        title:'',
        keywords:'',
        description:'',
      }
    },
  },
  {
    path: '/zh-CN',
    name: 'zh-CN',
    component: Index,
  },
  {// 关于我们
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs/index.vue'),
    children:[
      {// 企业简介
        path:'/Intro',
        name: 'Intro',
        component: () => import('../views/AboutUs/Intro.vue'),
      },
      {// 企业文化
        path:'/Culture',
        name: 'Culture',
        component: () => import('../views/AboutUs/Culture.vue'),
      },
      {// 员工风采
        path:'/Staff',
        name: 'Staff',
        component: () => import('../views/AboutUs/Staff.vue'),
      },
      {// 员工风采 详情
        path:'/SPreview',
        name: 'SPreview',
        component: () => import('../views/AboutUs/Preview.vue'),
      },
    ]
  },
  {// 产品中心
    path: '/ProductCenter',
    name: 'ProductCenter',
    component: () => import('../views/ProductCenter/index.vue'),
    children:[
      {// 产品列表
        path:'/Product',
        name: 'Product',
        component: () => import('../views/ProductCenter/Product.vue'),
      },{// 产品
        path:'/PDetail',
        name: 'PDetail',
        component: () => import('../views/ProductCenter/Detail.vue'),
      },
    ]
  },
  {// 工厂展示
    path: '/FactoryDisplay',
    name: 'FactoryDisplay',
    component: () => import('../views/FactoryDisplay/index.vue'),
    children:[
      {// 工厂风采
        path:'/Factory',
        name: 'Factory',
        component: () => import('../views/FactoryDisplay/Factory.vue'),
      },
      {// 工厂风采 详情
        path:'/FPreview',
        name: 'FPreview',
        component: () => import('../views/FactoryDisplay/Preview.vue'),
      },
    ]
  },
  {// 销售网络
    path: '/SalesNetwork',
    name: 'SalesNetwork',
    component: () => import('../views/SalesNetwork/index.vue'),
    children:[
      {// 销售网络
        path:'/Network',
        name: 'Network',
        component: () => import('../views/SalesNetwork/Network.vue'),
      },
    ]
  },
  {// 服务支持
    path: '/ServiceSupport',
    name: 'ServiceSupport',
    component: () => import('../views/ServiceSupport/index.vue'),
    children:[
      {// 服务支持
        path:'/Service',
        name: 'Service',
        component: () => import('../views/ServiceSupport/Service.vue'),
      },
    ]
  },
  {// 新闻动态
    path: '/NewsTrends',
    name: 'NewsTrends',
    component: () => import('../views/NewsTrends/index.vue'),
    children:[
      {// 集团要闻
        path:'/Enterprise',
        name: 'Enterprise',
        component: () => import('../views/NewsTrends/Enterprise.vue'),
      },
      {// 业务动态
        path:'/Business',
        name: 'Business',
        component: () => import('../views/NewsTrends/Business.vue'),
      },
      {// 拥军拥属
        path:'/Subsidiary',
        name: 'Subsidiary',
        component: () => import('../views/NewsTrends/Subsidiary.vue'),
      },
      {// 新闻 详情
        path:'/NDetail',
        name: 'NDetail',
        component: () => import('../views/NewsTrends/Detail.vue'),
      },
    ]
  },
  {// 联系我们
    path: '/ContactUs',
    name: 'ContactUs',
    component: () => import('../views/ContactUs/index.vue'),
    children:[
      {// 服务支持
        path:'/Contact',
        name: 'Contact',
        component: () => import('../views/ContactUs/Contact.vue'),
      },
    ]
  },

  {// 商城
    path:'/Mall',
    name: 'Mall',
    component: Mall,
    meta:{//初始化的meta
      isShow:true,
      title:'',
      content:{
        title:'',
        keywords:'',
        description:'',
      }
    },
  },
  {//
    path: '/Shop',
    name: 'Shop',
    component: () => import('../views/Shop/index.vue'),
    children:[
      {// 商城筛选
        path:'/Search',
        name: 'Search',
        component: () => import('../views/Shop/Search.vue'),
      },
      {// 商品详情
        path:'/Goods',
        name: 'Goods',
        component: () => import('../views/Shop/Goods.vue'),
      },
      {// 登录
        path:'/Login',
        name: 'Login',
        component: () => import('../views/Shop/Login.vue'),
      },
      {// 注册
        path:'/Register',
        name: 'Register',
        component: () => import('../views/Shop/Register.vue'),
      },
      {// 忘记密码
        path:'/FindPwd',
        name: 'FindPwd',
        component: () => import('../views/Shop/FindPwd.vue'),
      },
    ]
  },
  {// 购物
    path: '/Shopping',
    name: 'Shopping',
    component: () => import('../views/Cart/index.vue'),
    children:[
      {// 购物车
        path:'/Cart',
        name: 'Cart',
        component: () => import('../views/Cart/Cart.vue'),
      },
      {// 确认订单
        path:'/Confirm',
        name: 'Confirm',
        component: () => import('../views/Cart/Confirm.vue'),
      },
      {// 结算
        path:'/Results',
        name: 'Results',
        component: () => import('../views/Cart/Results.vue'),
      },
    ]
  },
  {// 我的
    path: '/Center',
    name: 'Center',
    component: () => import('../views/Mine/index.vue'),
    children:[
      {// 账户总览
        path:'/Mine',
        name: 'Mine',
        component: () => import('../views/Mine/Mine.vue'),
      },
      {// 帐户设置
        path:'/Setting',
        name: 'Setting',
        component: () => import('../views/Mine/Setting.vue'),
      },
      {// 我的订单
        path:'/Orders',
        name: 'Orders',
        component: () => import('../views/Mine/Orders.vue'),
      },
      {// 售后订单
        path:'/Refund',
        name: 'Refund',
        component: () => import('../views/Mine/Refund.vue'),
      },
      {// 订单详情
        path:'/OrderInfo',
        name: 'OrderInfo',
        component: () => import('../views/Mine/OrderInfo.vue'),
      },
      {// 评价
        path:'/Evaluate',
        name: 'Evaluate',
        component: () => import('../views/Mine/Evaluate.vue'),
      },
      {// 申请售后
        path:'/ApplyRefund',
        name: 'ApplyRefund',
        component: () => import('../views/Mine/ApplyRefund.vue'),
      },
      {// 分销中心
        path:'/Share',
        name: 'Share',
        component: () => import('../views/Mine/Share.vue'),
      },
      {// 权益说明
        path:'/Explain',
        name: 'Explain',
        component: () => import('../views/Mine/Explain.vue'),
      },
      {// 佣金明细
        path:'/Brokerage',
        name: 'Brokerage',
        component: () => import('../views/Mine/Brokerage.vue'),
      },
      {// 立即提现
        path:'/Withdraw',
        name: 'Withdraw',
        component: () => import('../views/Mine/Withdraw.vue'),
      },
      {// 提现明细
        path:'/WithdrawInfo',
        name: 'WithdrawInfo',
        component: () => import('../views/Mine/WithdrawInfo.vue'),
      },
      {// 分享记录
        path:'/ShareInfo',
        name: 'ShareInfo',
        component: () => import('../views/Mine/ShareInfo.vue'),
      },
      {// 我的下级
        path:'/Junior',
        name: 'Junior',
        component: () => import('../views/Mine/Junior.vue'),
      },
      {// 下级的下级
        path:'/JuniorLevel',
        name: 'JuniorLevel',
        component: () => import('../views/Mine/JuniorLevel.vue'),
      },
      {// 商品收藏
        path:'/Collection',
        name: 'Collection',
        component: () => import('../views/Mine/Collection.vue'),
      },
      {// 历史浏览
        path:'/History',
        name: 'History',
        component: () => import('../views/Mine/History.vue'),
      },
      {// 收货地址
        path:'/Address',
        name: 'Address',
        component: () => import('../views/Mine/Address.vue'),
      },
      {// 优惠券
        path:'/Coupons',
        name: 'Coupons',
        component: () => import('../views/Mine/Coupons.vue'),
      },
      {// 帮助中心
        path:'/Help',
        name: 'Help',
        component: () => import('../views/Mine/Help.vue'),
      },
      {// 申请开票
        path:'/InvoiceApply',
        name: 'InvoiceApply',
        component: () => import('../views/Mine/InvoiceApply.vue'),
      },
    ]
  },

  {
    path: '*',
    component: NoFound
  }
]
// 商城
const routesShop = [
  {// 商城
    path:'/',
    name: 'Mall',
    component: Mall,
    meta:{//初始化的meta
      isShow:true,
      title:'',
      content:{
        title:'',
        keywords:'',
        description:'',
      }
    },
  },
  {//
    path: '/Shop',
    name: 'Shop',
    component: () => import('../views/Shop/index.vue'),
    children:[
      {// 商城筛选
        path:'/Search',
        name: 'Search',
        component: () => import('../views/Shop/Search.vue'),
      },
      {// 商品详情
        path:'/Goods',
        name: 'Goods',
        component: () => import('../views/Shop/Goods.vue'),
      },
      {// 登录
        path:'/Login',
        name: 'Login',
        component: () => import('../views/Shop/Login.vue'),
      },
      {// 注册
        path:'/Register',
        name: 'Register',
        component: () => import('../views/Shop/Register.vue'),
      },
      {// 忘记密码
        path:'/FindPwd',
        name: 'FindPwd',
        component: () => import('../views/Shop/FindPwd.vue'),
      },
    ]
  },
  {// 购物
    path: '/Shopping',
    name: 'Shopping',
    component: () => import('../views/Cart/index.vue'),
    children:[
      {// 购物车
        path:'/Cart',
        name: 'Cart',
        component: () => import('../views/Cart/Cart.vue'),
      },
      {// 确认订单
        path:'/Confirm',
        name: 'Confirm',
        component: () => import('../views/Cart/Confirm.vue'),
      },
      {// 结算
        path:'/Results',
        name: 'Results',
        component: () => import('../views/Cart/Results.vue'),
      },
    ]
  },
  {// 我的
    path: '/Center',
    name: 'Center',
    component: () => import('../views/Mine/index.vue'),
    children:[
      {// 账户总览
        path:'/Mine',
        name: 'Mine',
        component: () => import('../views/Mine/Mine.vue'),
      },
      {// 帐户设置
        path:'/Setting',
        name: 'Setting',
        component: () => import('../views/Mine/Setting.vue'),
      },
      {// 我的订单
        path:'/Orders',
        name: 'Orders',
        component: () => import('../views/Mine/Orders.vue'),
      },
      {// 售后订单
        path:'/Refund',
        name: 'Refund',
        component: () => import('../views/Mine/Refund.vue'),
      },
      {// 订单详情
        path:'/OrderInfo',
        name: 'OrderInfo',
        component: () => import('../views/Mine/OrderInfo.vue'),
      },
      {// 评价
        path:'/Evaluate',
        name: 'Evaluate',
        component: () => import('../views/Mine/Evaluate.vue'),
      },
      {// 申请售后
        path:'/ApplyRefund',
        name: 'ApplyRefund',
        component: () => import('../views/Mine/ApplyRefund.vue'),
      },
      {// 分销中心
        path:'/Share',
        name: 'Share',
        component: () => import('../views/Mine/Share.vue'),
      },
      {// 权益说明
        path:'/Explain',
        name: 'Explain',
        component: () => import('../views/Mine/Explain.vue'),
      },
      {// 佣金明细
        path:'/Brokerage',
        name: 'Brokerage',
        component: () => import('../views/Mine/Brokerage.vue'),
      },
      {// 立即提现
        path:'/Withdraw',
        name: 'Withdraw',
        component: () => import('../views/Mine/Withdraw.vue'),
      },
      {// 提现明细
        path:'/WithdrawInfo',
        name: 'WithdrawInfo',
        component: () => import('../views/Mine/WithdrawInfo.vue'),
      },
      {// 分享记录
        path:'/ShareInfo',
        name: 'ShareInfo',
        component: () => import('../views/Mine/ShareInfo.vue'),
      },
      {// 我的下级
        path:'/Junior',
        name: 'Junior',
        component: () => import('../views/Mine/Junior.vue'),
      },
      {// 下级的下级
        path:'/JuniorLevel',
        name: 'JuniorLevel',
        component: () => import('../views/Mine/JuniorLevel.vue'),
      },
      {// 商品收藏
        path:'/Collection',
        name: 'Collection',
        component: () => import('../views/Mine/Collection.vue'),
      },
      {// 历史浏览
        path:'/History',
        name: 'History',
        component: () => import('../views/Mine/History.vue'),
      },
      {// 收货地址
        path:'/Address',
        name: 'Address',
        component: () => import('../views/Mine/Address.vue'),
      },
      {// 优惠券
        path:'/Coupons',
        name: 'Coupons',
        component: () => import('../views/Mine/Coupons.vue'),
      },
      {// 帮助中心
        path:'/Help',
        name: 'Help',
        component: () => import('../views/Mine/Help.vue'),
      },
      {// 申请开票
        path:'/InvoiceApply',
        name: 'InvoiceApply',
        component: () => import('../views/Mine/InvoiceApply.vue'),
      },
    ]
  },
  {
    path: '*',
    component: NoFound
  }
]
// 官网
export var routes = routesIndex;
// 商城
// export var routes = routesShop;

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if(!window.localStorage.getItem('language')){
    let lang = window.localStorage.getItem('language') || 'zh-CN'; // 国内站默认中文
    if (to.path === '/zh-CN') {
      lang = 'zh-CN';
    } else if (to.path === '/en') {
      lang = 'en';
    }

    // 保存语言到 localStorage
    window.localStorage.setItem('language', lang);
  }

  next(); // 继续路由跳转
});

/* 
  权限控制：把不需要登录的页面 称为 白名单 

*/

export default router
